import createAxiosInstance from "../support/AxiosSupport";

/**
 * Потребление одной квоты за текущий период (зеркало backend QuotaUsageDto, CTHS-19).
 * {@code limit === -1} — безлимит; при безлимите {@code remaining === -1}.
 */
export interface QuotaUsage {
    quotaType: string;
    used: number;
    limit: number;
    remaining: number;
    periodStart: string | null;
    periodEnd: string | null;
}

/**
 * Эффективная подписка пользователя (зеркало backend SubscriptionDto, CTHS-19).
 * {@code self} — является ли текущий пользователь владельцем подписки: для участника
 * family-плана это {@code false} (он видит общий лимит, но не управляет тарифом).
 */
export interface Subscription {
    id: string;
    ownerId: string;
    self: boolean;
    planCode: string;
    planName: string;
    status: string;
    startedAt: string | null;
    expiresAt: string | null;
    currentPeriodStart: string | null;
    currentPeriodEnd: string | null;
    maxWardrobes: number;
    maxFamilyMembers: number;
    /** Открывает ли тариф premium-аналитику: по нему меню помечает закрытые разделы (R17). */
    premiumAnalytics: boolean;
    /** Открывает ли тариф платформенный AI-ключ: при {@code false} AI-квота не расходуется. */
    platformAiEnabled: boolean;
    quotas: QuotaUsage[];
}

/**
 * Загружает эффективную подписку текущего пользователя ({@code GET /api/subscription/current}).
 * Эндпоинт owner-scoped по JWT — отдаёт только данные самого пользователя (без IDOR).
 */
export const fetchCurrentSubscription = async (): Promise<Subscription> => {
    const api = await createAxiosInstance();
    const res = await api.get<Subscription>('/subscription/current');
    return res.data;
};
